import React from 'react'
import './styles.css'
const LoaderSVG = require('./loader.svg') as string

interface InfScrollProps {
  children:any,
  loader?:any,
  onReachEnd:()=>Promise<unknown>|any,
  showLoader?:boolean,
  triggerSize?:string,
  adaptive?:boolean|string
}

/** @description InfScroll - модуль бесконечной прогрузки*.
 * @typedef {Object<any>} Props
 * @property {any} children элемент(ы), находящийся внутри.
 * @property {any} loader элемент загрузки или текст.
 * @property {()=>Promise<unknown>} onReachEnd функция, вызываемая при достижении конца списка.
 * @property {boolean} showLoader выключатель компонента загрузки.
 * @property {string} triggerSize размер зоны срабатывания (50px).
 * @example 
 * <InfScroll onReachEnd={changeData} showLoader={true}>
		  {data.map((_,i)=><Card key={i} i={i}/>)}
	  </InfScroll>
 */
export const InfScroll: React.FC<InfScrollProps> = ({
  children,
  loader=<img id="InfScrollLoader" src={LoaderSVG} alt="Загрузка ..." />,
  onReachEnd,
  showLoader=true,
  triggerSize='50px',
  adaptive=false
}) => {
  const rootRef = React.createRef<HTMLDivElement>();
  const bottomRef = React.createRef<HTMLDivElement>();
  const [isLoading, setLoading] = React.useState<boolean>(false);

  const scrollCallback = async (entries: IntersectionObserverEntry[]) => {
    if (entries[0].isIntersecting&&!isLoading) {
      setLoading(true);
      await onReachEnd()
      setTimeout(() => {
        setLoading(false);
      }, 500);
    }
  };

  const getSize = ({...elements}) => {
		const sizes = Object.entries(elements)
		.reduce((acc:any, [k, v]:any) => (acc[k] = (v.getBoundingClientRect()).height, acc), {})
		return sizes;
	}

	const getFreeSpace = (parentName:string) => {
    try {
      const body = document.body;
      const panel:any = document.querySelector(parentName);
      const infScroll:any = body.querySelector('#InfScrollRoot')
      const sizes:any = getSize({panel,body})
      const size:number = sizes.panel-sizes.body
      if (size!==0) infScroll.style.height = `calc(100vh - ${size}px)`
    } catch (error) {
      console.log(error)
    }
	}

  React.useEffect(() => {
    const scroll = new IntersectionObserver(scrollCallback, {
      root: rootRef.current!,
      rootMargin: triggerSize
    });
    scroll.observe(bottomRef.current!);
    return () => {
      scroll.disconnect();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rootRef, bottomRef]);

  return <div id="InfScrollRoot" ref={rootRef} onLoad={()=>typeof adaptive==='string'&&getFreeSpace(adaptive)}>
    {children}
    <div ref={bottomRef} />
    {showLoader&&loader}
  </div>
}

export default InfScroll